import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PaymentTransactionDetailContent } from './PaymentTransactionDetailContent';

export default function PaymentTransactionDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <PaymentTransactionDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
